import withAuthHeader from "../../utils/withAuthHeader";
import checkAuthorizationError from "../../utils/checkAuthorizationError";
import {
  mapFetchClientsListRequest,
  mapFetchClientsListResponse,
  mapFetchClientDetailResponse,
  mapFetchLoyaltyDetailResponse,
} from "../mappers/clients";
import qs from "querystring";
import { api } from "../store";

export const getClientsFetch = async (filters) => {
  let result = {};
  try {
    const queryString = qs.stringify({
      Nome: filters.name,
      Email: filters.email,
      Cpf: filters.documentNumber,
    });
    const url = `api/v1/dashboard/clientes?${queryString}`;

    const apiResponse = await api.get(url, {
      qs: queryString,
      ...withAuthHeader(),
    });
    const response = mapFetchClientsListResponse(apiResponse.data);
    result = {
      success: true,
      data: response,
    };
  } catch (e) {
    checkAuthorizationError(e);
    result = {
      error: e.message,
    };
  }
  return result;
};

export const fetchClientsList =
  (filters, viewMore, clients) => async (dispatch, getState, api) => {
    console.log(filters, viewMore, clients)
    let result = {};
    try {
      const queryString = qs.stringify({
        Nome: filters.name,
        Email: filters.email,
        Cpf: filters.documentNumber,
      });
      const url = `api/v1/dashboard/clientes?${queryString}`;

      const apiResponse = await api.get(url, {
        qs: queryString,
        ...withAuthHeader(),
      });
      const response = mapFetchClientsListResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const fetchClientDetail =
  (clientId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/dashboard/clientes/${clientId}`;
      const apiResponse = await api.get(url, {
        ...withAuthHeader(),
      });
      const response = mapFetchClientDetailResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const fetchLoyaltyDetail =
  (clientId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/dashboard/clientes/obterdadosfidelidade/${clientId}`;
      const apiResponse = await api.get(url, {
        ...withAuthHeader(),
      });
      const response = mapFetchLoyaltyDetailResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };
